import { create } from 'zustand';

/**
 * Which account-based feature a guest tried to use. Drives the copy in
 * `AccountGateModal`. Mirrors the iOS `AccountGateSheet` triggers.
 */
export type AccountGateFeature =
  | 'save'
  | 'reading-plan'
  | 'quiz'
  | 'resources'
  | 'reviews'
  | 'read-aloud'
  | 'amazon'
  | 'learn-with-ollie'
  | 'generic';

/**
 * AccountGateStore — the guest → account conversion prompt, modeled on
 * `usePaywallStore`. A single `AccountGateModal` is mounted at the App root
 * and driven by this store; any gated affordance calls `openAccountGate`.
 * Distinct from the paywall (subscription upgrade) — this is for visitors
 * with no account at all.
 */
export interface AccountGateState {
  open: boolean;
  feature: AccountGateFeature | null;
  openAccountGate: (feature: AccountGateFeature) => void;
  closeAccountGate: () => void;
}

export const useAccountGateStore = create<AccountGateState>((set) => ({
  open: false,
  feature: null,
  openAccountGate: (feature) => set({ open: true, feature }),
  closeAccountGate: () => set({ open: false }),
}));
